import { Suspense } from "react";
import { CircularProgress, Typography } from "@mui/material";

import { useConfig } from "../../hooks/settingHooks";
import { useTranslation } from "react-i18next";

import { ConfigErrorFallback } from "../boundary/ConfigErrorFallback";
import { FlexCentered } from "../layout/FlexCenterd";
import { ProccessSettings } from "../settings/ProccessSettings";
import { ErrorBoundary } from "react-error-boundary";

export function ConfigSettingsGuard() {
  const { t } = useTranslation();
  const config = useConfig();

  return (
    <>
      {config && (
        <ErrorBoundary FallbackComponent={ConfigErrorFallback}>
          <Suspense
            fallback={
              <FlexCentered column>
                <CircularProgress sx={{ color: "#fff" }} />
                <Typography variant="caption" color="white" marginTop={1}>
                  {t("label.loadingSettingsFor", { config })}
                </Typography>
              </FlexCentered>
            }
          >
            <ProccessSettings config={config} />
          </Suspense>
        </ErrorBoundary>
      )}
    </>
  );
}
